module.exports = __webpack_public_path__ + "assets/img/product-function-new.f4e6fcc0.png";